import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  Competitor,
  CompetitorSaveControlPointResultStatus,
  EventItem,
  MeasurementTimeItemHolder, RaceSettings,
  Waypoint
} from "@model";
import {NgbActiveOffcanvas} from "@ng-bootstrap/ng-bootstrap";
import {MeasurementsService, MeasurementTimeItemHolderService} from "@services";
import {AbstractComponent} from "../abstract.component";

@Component({
    selector: 'app-timing-cache-offcanvas',
    templateUrl: './timing-cache-offcanvas.component.html',
    styleUrl: './timing-cache-offcanvas.component.scss',
    standalone: false
})
export class TimingCacheOffcanvasComponent extends AbstractComponent{
  @Input() event: EventItem | undefined;
  @Input() waypoint: Waypoint | undefined;
  @Input() isRoundRace: boolean = false;
  @Input() raceSettingsMap: Map<number, RaceSettings> = new Map<number, RaceSettings>();
  @Output() delete = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();

  isSaving: boolean = false;
  displayErrorsMap: Map<number, boolean> = new Map<number, boolean>();
  measurementTimeItemHolders: MeasurementTimeItemHolder[] = [];


  constructor(public activeOffcanvas: NgbActiveOffcanvas, private measurementsService: MeasurementsService, private measurementTimeItemHolderService: MeasurementTimeItemHolderService) {
    super()
  }


  ngOnInit() {
    this.displayErrorsMap.clear();
    this.subscriptions.push(this.measurementTimeItemHolderService.currentHolder.subscribe(value => {
      this.measurementTimeItemHolders = value ?? [];
      this.displayErrorsMap.clear();
      this.isSaving = false;
      this.measurementTimeItemHolders.forEach((item, index) => {
        this.isSaving = this.isSaving || (item.inProgress ?? false);
        this.displayErrorsMap.set(index, false);
      });
      if (this.measurementTimeItemHolders.length == 0) {
        this.activeOffcanvas?.dismiss();
      }
    }))
  }

  dismiss(reason?: string) {
    this.activeOffcanvas.dismiss(reason);
  }

  onDelete() {
    if (!this.isSaving) {
      this.delete.emit();
    }
  }


  onSave() {
    if (!this.isSaving) {
      this.measurementsService.ping().subscribe(isOnline => {
        if (isOnline) {
        const competitors: Competitor[] = [];
        this.measurementTimeItemHolders.forEach(item => {
          if (item.competitor) {
            item.inProgress = true;
            competitors.push(item.competitor)
          }
        });
        this.saveToCache(this.measurementTimeItemHolders);
        if (this.event?.id && ((competitors.length ?? 0) > 0)) {
          this.isSaving = true;
          this.measurementsService.saveStartNumberControlPoints(competitors!, this.event.id!, (result) => {
            const itemHolders: MeasurementTimeItemHolder[] = [];

            this.measurementTimeItemHolders.forEach(holder => {
              holder.inProgress = false;
            });

            result.forEach(r => {
              if (r.status !== CompetitorSaveControlPointResultStatus.OK) {
                itemHolders.push({
                  competitor: r.competitor,
                  saveResult: r.status,
                  startNumber: r.competitor?.startNumber,
                  time: r.competitor?.controlPointsTimes?.at(0)?.time,
                  inProgress: false
                });
              }
            });

            itemHolders.sort((a, b) => {
              const timeA = a.time ? new Date(a.time).getTime() : 0;
              const timeB = b.time ? new Date(b.time).getTime() : 0;
              return timeA - timeB;
            });

            this.saveToCache(itemHolders);
            this.isSaving = false;
          }, () => {
            this.measurementTimeItemHolders.forEach(holder => holder.inProgress = false);
            this.isSaving = false;
            this.saveToCache(this.measurementTimeItemHolders);
          });
        }
      }
      })
    }
  }

  saveToCache(items: MeasurementTimeItemHolder[] | undefined) {
    this.measurementTimeItemHolderService.saveHolderForEventCheckPoint(
        !this.isRoundRace,
        this.event!.id!,
        this.waypoint?.id,
        items ?? []
    );
  }

  showError(idx: number) {
    if (this.measurementTimeItemHolders.at(idx)?.saveResult !== CompetitorSaveControlPointResultStatus.OK) {
      this.displayErrorsMap.set(idx, !this.displayErrorsMap.get(idx));
    }
  }


  protected readonly CompetitorSaveControlPointResultStatus = CompetitorSaveControlPointResultStatus;

  override ngOnDestroy() {
    super.ngOnDestroy();
  }
}
